<template>
  <div class="gp-content admin">
    <content-tab-bar :tabs="tabs" :showLabels="true"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'AdminSection',
  components: { ContentTabBar },
  computed: {
    tabs() {
      return [
        // {
        //   label: 'DashBoards',
        //   link: {
        //     name: 'admin.dashboards.index',
        //   },
        //   icon: 'dashboard',
        // },
        {
          label: 'Organizations',
          link: {
            name: 'admin.organizations.index',
          },
          activeLinks: [
            'admin.organizations.index',
            'admin.organizations.index.detail',
            'admin.organizations.index.create',
          ],
          icon: 'org',
        },
        {
          label: 'Analytics',
          link: {
            name: 'admin.analytics.index',
          },
          activeLinks: [
            'admin.analytics.index',
            'admin.analytics.index.detail',
            'admin.analytics.index.create',
            'admin.analytics.index.edit',
            'admin.analytics.index.delete',
          ],
          icon: 'logic',
        },
        {
          label: 'Releases',
          link: {
            name: 'admin.releases.index',
          },
          activeLinks: [
            'admin.releases.index',
            'admin.releases.index.detail',
            'admin.releases.index.create',
          ],
          icon: 'pkg',
        },
      ];
    },
  },
  mounted() {
    this.SET_SECTION('Admin');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>

<style lang="scss" scoped>
/deep/ .tabs {
  background-color: #5A5757;

  ul {
    border-bottom-color: $form-subitem;

    li.is-active a {
      border-bottom-color: whitesmoke;
      color: whitesmoke;
    }

    li {
      a {
        border-bottom-color: $main-background;
        color: #92908D;
      }

      a:hover {
        border-bottom-color: whitesmoke;
        color: whitesmoke;
      }
    }

    a {
      color: $main-background;
    }

    a:hover {
      color: $main-background;
    }
  }
}
</style>
